export const messages = {
  requiredEmail: "Vui lòng nhập email",
  validateEmail: "Email không đúng định dạng",
  error: "Lỗi. Vui lòng thử lại sau.",
  updateSuccess: "Cập nhật thành công.",
  addSuccess: "Tạo thành công.",
  deleteSuccess: "Xóa thành công.",
  importSuccess: "Quá trình import đang diễn ra",
};
